import { call } from 'redux-saga/effects';
import appHandler from '../appHandler';
import { handleError } from '../commonHandlers';
import { handleGetContentSuccess } from './contentHandler';

function* getUserRoles(api, action) {
  const response = yield call(api, action.payload);
  appHandler.route(action, response, handleGetContentSuccess, handleError);
}

export default {
  getUserRoles,
};
